import React, {useContext, useEffect} from 'react';
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import {SellFactorSCLContext} from "./SellFactorContext";
import numericFunction from "../../utils/NumericFunction";
import DatePickerSellScl from "./components/DatePickerSellScl";
import FactorTypeSellScl from "./components/FactorTypeSellScl";
import FactorSellSclStatus from "./components/FactorSellSclStatus";
import FactorSellSclRlookUp from "./FactorSellSclRlookUp";
import FactorSellSclTax from "./components/FactorSellSclTax";
import FactorSellSclDiscount from "./components/FactorSellSclDiscount";
import SubmitButton from "./components/SubmitButton";


function SellSclFactorKol(props) {

  const helper = useContext(SellFactorSCLContext);
  const setData = helper.setData
  const data = helper.data


  console.log(data)

  try {
    return (<div>

      {/*<DatePickerSellScl/>*/}
      <FactorTypeSellScl/>
      <FactorSellSclStatus/>
      <FactorSellSclRlookUp
        rlookupId={data.initialData.deliveryRLookUpId}
        defaultCaption={"انتخاب مرکز تحویل"}
        captionAfterSelect={"مرکز"}
        valueAfterSelect={data.sendData.deliveryId ? data.sendData.deliveryName + "  " + data.sendData.deliveryType : undefined}

        functionAfterSelect={(backObject) => {
          setData({
            sendData: {
              ...data.sendData, deliveryId: backObject.na_123,
              deliveryType: backObject.na_128,
              deliveryName: backObject.na_124
            }
          })
        }}

      />
      <FactorSellSclRlookUp
        rlookupId={data.initialData.addressRLookUpId}
        defaultCaption={"آدرس مرکز تحویل"}
        captionAfterSelect={"آدرس: "}
        valueAfterSelect={data.sendData.addressText}

        functionAfterSelect={(backObject) => {
          setData({
            sendData: {
              ...data.sendData, addressId: backObject.na_251, addressText: backObject.na_252,
            }
          })
        }}
        variables={JSON.stringify({na_123: data.sendData.deliveryId})}
        variableIsStringify={true}
      />

      <FactorSellSclRlookUp
        rlookupId={data.initialData.driverRLookUpId}
        defaultCaption={"انتخاب راننده"}
        captionAfterSelect={"راننده: "}
        valueAfterSelect={data.sendData.driverName}
        backRlookUpId={""} // بک اند توی آر کولاپ یه آیدی میفرسته کلید داره
        backRlookUpText={""} // بک اند توی آر کولاپ یه آیدی میفرسته کلید داره
        functionAfterSelect={(backObject) => {
          setData({
            sendData: {
              ...data.sendData, driverId: backObject.na_129, driverName: backObject.na_130,
            }
          })
        }}

      />

      {/*<FactorSellSclTax/>*/}
      {/*<FactorSellSclDiscount/>*/}
      <SubmitButton />


    </div>);
  } catch (error) {
    return <>{error.toString()}</>
  }
}

export default SellSclFactorKol;